// Module
var code = "<gradient-banner custom-class=\"expired-info-banner\" start-color=\"#F19E3F\" end-color=\"#F19E3F\" paddingTopBottom=\"12px\" icon-name=\"warning\" action-label=\"CONFIRM\" action-icon-template=\"'<icon-thumb-up></icon-thumb-up>'\" on-action=\"vm.onConfirm()\" ng-attr-text=\"{{vm.message}}\"> </gradient-banner> ";
// Exports
module.exports = code;